import { notification } from 'antd';

export const notificationService = (
  status: { success?: boolean; error?: boolean },
  mes: string
) => {
  const args = {
    message: mes,
    description: 'Gracias =)'
  };
  const errorArgs = {
    message: mes,
    description: 'Lo siento =('
  };
  if (status.success) {
    setTimeout(() => notification.success(args), 0);
  } else if (status.error) {
    setTimeout(() => notification.error(errorArgs), 0);
  }
};
